import React from 'react';
import { PLAYERS_STATUS } from '../../constants';
import PlayersTemplateTableCell from './PlayersTemplateTableCell';

const PlayersTemplatePreviewRows = (props) => {
  const getClassName = (operationName) => ['event-selection__row',
    operationName !== PLAYERS_STATUS.updatedPlayers ? `--${operationName.toLowerCase()}` : ''].join('');
  const statusList = Object.keys(props.playersGroupByStatus);
  return (
    statusList?.map((status) => {
      const playersStatusName = PLAYERS_STATUS[status];
      return props.playersGroupByStatus[status].length > 0
            && props.playersGroupByStatus[status]
              .map((playersTemplate) => (playersStatusName === PLAYERS_STATUS.updatedPlayers
                ? (
                  <tr key={playersTemplate?.playerId} className={getClassName(playersStatusName)}>
                    <td>{props.team?.name}</td>
                    <td>{playersStatusName}</td>
                    <td>
                      <PlayersTemplateTableCell
                        type="text"
                        oldValue={playersTemplate?.oldPlayerName}
                        newValue={playersTemplate?.playerName}
                      />
                    </td>
                    <td>
                      <PlayersTemplateTableCell
                        type="text"
                        oldValue={playersTemplate?.oldReferenceName}
                        newValue={playersTemplate?.referenceName}
                      />
                    </td>
                    <td>
                      <PlayersTemplateTableCell
                        type="number"
                        oldValue={playersTemplate?.oldPlayerPosition}
                        newValue={playersTemplate?.playerPosition}
                      />
                    </td>
                    <td>
                      <PlayersTemplateTableCell
                        type="number"
                        oldValue={playersTemplate?.oldPlayerProbability}
                        newValue={playersTemplate?.playerProbability}
                      />
                    </td>
                  </tr>
                ) : (
                  <tr key={playersTemplate?.playerId} className={getClassName(playersStatusName)}>
                    <td>{props.team?.name}</td>
                    <td>{playersStatusName}</td>
                    <td>{playersTemplate?.playerName}</td>
                    <td>{playersTemplate?.referenceName}</td>
                    <td>{playersTemplate?.playerPosition || '-'}</td>
                    <td>{playersTemplate?.playerProbability || '-'}</td>
                  </tr>
                )));
    })
  );
};
export default PlayersTemplatePreviewRows;
